import { Box } from '@dtx-company/shared-components/src/components/atoms/Box'
import { Button } from '@dtx-company/design-system/src'
import { FC, useMemo } from 'react'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { NAV_V2_LOGGED_OUT_LINKS_BP } from '@dtx-company/true-common/src/constants/layout'
import { NextLinkWrap } from '@app/page/src/components/util/NextLinkUtils'
import { REDIRECT_TO_CURR_STORE_PAGE_POST_AUTH_ROUTES } from './MarketingNavLinks.constants'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer'
import { media } from '@dtx-company/shared-components/src/theme/media-queries'
import { useRouter } from 'next/router'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'
import styled from 'styled-components'
import useTranslation from 'next-translate/useTranslation'

const DesktopWrapper = styled(Box)`
  display: none;

  ${media.custom(NAV_V2_LOGGED_OUT_LINKS_BP)} {
    display: flex;
  }
`

export const SignInOptions: FC<{ isFPHomepage: boolean }> = ({ isFPHomepage }) => {
  const { t } = useTranslation('nav')
  const router = useRouter()
  const query = useMemo(() => {
    const redirectToCurrStorePage = REDIRECT_TO_CURR_STORE_PAGE_POST_AUTH_ROUTES.includes(
      router.pathname as Routes
    )
    return {
      ...(!redirectToCurrStorePage && { ...router.query }),
      ...(redirectToCurrStorePage && {
        redirectTo: router.asPath
      }),
      flowpage: isFPHomepage
    }
  }, [router.pathname, isFPHomepage, router.asPath, router.query])

  return (
    <DesktopWrapper marginLeft="auto" alignItems="center" pr="32px">
      <NextLinkWrap
        flexShrink={0}
        href={{
          pathname: FLOWCODE_ROOT + Routes.SIGN_IN,
          query
        }}
        data-testid="marketing-nav-desktop-signin"
        display={'inline-block'}
      >
        <Button
          variant="text"
          fullWidth
          onClick={() => {
            events.Global_MarketingNav_Clicked_SigninButton()
          }}
          data-heap-id="Global_MarketingNav_Clicked_SigninButton"
        >
          {t('Header.v2.SignIn')}
        </Button>
      </NextLinkWrap>
      <Spacer mr="16px" />
      <Box minWidth="70px">
        <NextLinkWrap
          flexShrink={0}
          href={{
            pathname: FLOWCODE_ROOT + Routes.SIGN_UP,
            query
          }}
          data-testid="marketing-nav-desktop-signup"
        >
          <Button
            fullWidth
            color="tertiary"
            onClick={() => events.Global_MarketingNav_Clicked_SignupButton()}
            data-heap-id="Global_MarketingNav_Clicked_SignupButton"
          >
            {t('Header.v2.SignUp')}
          </Button>
        </NextLinkWrap>
      </Box>
    </DesktopWrapper>
  )
}
